/* eslint-disable max-len */
/**
 * @file 个人中心路由
 * @author gaoxunchen
 */

import _ from 'lodash';
import React from 'react';
import { Loading } from '@tencent/ptp-fe-common';
import loadable from '@loadable/component';

export default [
  {
    key: 'ai-agent',
    label: 'AI 助理',
    href: '/analysis/(ai-agent|ai-dashboard)',
    hide: true,
    component: loadable(() => import(/* webpackChunkName: 'ai-agent' */ /* webpackMode: 'lazy' */ '@/ai-assistant/modules/analysis'), { fallback: <Loading /> }),
  },
];
